import { render, staticRenderFns } from "./CurvilinearMotionViz.vue?vue&type=template&id=5564c8bf&scoped=true"
import script from "./CurvilinearMotionViz.vue?vue&type=script&lang=js"
export * from "./CurvilinearMotionViz.vue?vue&type=script&lang=js"
import style0 from "./CurvilinearMotionViz.vue?vue&type=style&index=0&id=5564c8bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5564c8bf",
  null
  
)

export default component.exports